'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _InfoCircleFilled = _interopRequireDefault(require('./lib/icons/InfoCircleFilled'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _InfoCircleFilled;
exports.default = _default;
module.exports = _default;